import { render } from "./PackagesManagerOrdersGeneratorPricingStage.vue?vue&type=template&id=936b0242"
import script from "./PackagesManagerOrdersGeneratorPricingStage.vue?vue&type=script&lang=js"
export * from "./PackagesManagerOrdersGeneratorPricingStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__